import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { Promise } from 'q';

@Injectable()
export class AuthService {

  user: Observable<firebase.User>;
  superUser = false;
  admin = false;
  userEmail = '';

  constructor(public afAuth: AngularFireAuth) {
    this.user = this.afAuth.authState;
    this.login();
    this.afAuth.auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        this.superUser = !user.isAnonymous;
        this.admin = (user.email === 'md@mawitdruk.com' || user.email === 'dudziks@gmail.com');
        this.userEmail = user.email;
      } else {
        // No user is signed in.
      }
    });
  }

  setPersistance() {
    return this.afAuth.auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  }

  login() {
    // console.log('auth login');
    this.setPersistance()
      .then(function () {

        firebase.auth().signInAnonymously()
          .then(u => {
          })
          .catch(e => { });
      })
      .catch(function (error) {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
      });
  }

  logout() {
    this.afAuth.auth.signOut();
  }

  signIn(email: string, password: string) {
    // console.log('auth signIn');
    return this.setPersistance()
      .then(function () {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        // return firebase.auth().signInWithEmailAndPassword(email, password);

        return firebase.auth().signInWithEmailAndPassword(email, password);
      })
      .catch(function (error) {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
        return firebase.auth().signInWithEmailAndPassword(email, password);
      });

  }

  registerUser(email: string, password: string) {

    // console.log('auth registerUser');
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password);
  }

  isSuperUser(): boolean {
    return this.superUser;
  }

  isAdmin(): boolean {
    return this.admin;
  }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/auth.service.ts